import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import moment from 'moment';
import ReactTooltip from 'react-tooltip'
import Loader from '../components/Loader';

class GiftFinder extends Component {

    constructor(props) {
        super(props);

        let submitted, loading, questionSequence
        moment().utcOffset(8)

        this.state = {
            person: '',
            budget: '',
            location: '',
            delivery: '',
            submitted,
            loading,
            questionSequence: 1
        };
    }

    handleFeedback = () => {

        let { name, email, subject, message, questionSequence } = this.state;

        if(!questionSequence && message){
            this.setState({ 
                questionSequence: 1 });

            return
        }

        this.setState({ loading: true });        

        return api('/api/feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: email,
                email,
                subject : 'Exit Intent',
                message
            })
        }).then(result => {

            this.setState({ loading: false,
                questionSequence: 2 });        

            if(result){
                this.setState({ 
                submitted: true });        
            }
        })
    }

    handleForWhoClick = (value) => {

        this.setState({ person: value, questionSequence: 2 });
        let { budget, location, delivery } = this.state;
        
        // this.sendToServer(value, budget, location, delivery);
    }

    handleBudgetClick = (value) => {

        this.setState({ budget: value, questionSequence: 3 });
        let { person, location, delivery } = this.state;
        
        // this.sendToServer(person, value, location, delivery);
    }

    handleLocationClick = (value) => {


        if(value === 'KL+%26+Selangor+(On-Demand+Delivery)'){
            this.setState({ location: value, questionSequence: 4 });
        } else {
            this.setState({ location: value, questionSequence: 5 });

            let { person, budget, delivery } = this.state;
        
            this.sendToServer(person, budget, value, delivery);
        }
    }

    handleDeliveryClick = (value) => {

        this.setState({ delivery: value, questionSequence: 5 });
        let { person, budget, location } = this.state;
        
        this.sendToServer(person, budget, location, value);
    }

    handleTryAgainClick = (value) => {

        this.setState({ 
            person: '',
            budget: '',
            location: '',
            delivery: '',
            questionSequence: 1 });
    }

    sendToServer = (person, budget, location, delivery) => {

        return api('/api/gift_finder', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                who: decodeURIComponent(person),
                budget: decodeURIComponent(budget),
                where: decodeURIComponent(location),
                delivery: decodeURIComponent(delivery)
            })
        })
    }

    render() {
        const { error } = this.props
        const { person, budget,location,delivery, loading, questionSequence, submitted } = this.state;
    
        let style = {
            border:'none',
            overflow:'hidden'
           }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            {
                                questionSequence === 1 &&
                                <div className="exit-intent-title">
                                    <h3>Who are you sending to?</h3>
                                </div>
                            }
                            {
                                questionSequence === 2 &&
                                <div className="exit-intent-title">
                                    <h3>How much is your budget?</h3>
                                </div>
                            }
                            {
                                questionSequence === 3 &&
                                <div className="exit-intent-title">
                                    <h3>Where are you sending to?</h3>
                                </div>
                            }
                            {
                                questionSequence === 4 &&
                                <div className="exit-intent-title">
                                    <h3>When is the expected delivery date?</h3>
                                </div>
                            }
                            {
                                questionSequence === 5 &&
                                <div className="exit-intent-title">
                                    <h3>We found gifts for you.</h3>
                                </div>
                            }
                            {
                                questionSequence === 1 &&
                                <div className="form-group container">    
                                    <div className="row">
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" data="For Her" onClick={() => this.handleForWhoClick("For+Her")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/4_6017d25c-0129-40b5-ba3c-5dfb46ead9e7.png?8527693493550499837" className="img-responsive img-circle"/>For Her</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" data="For Him" onClick={() => this.handleForWhoClick("For+Him")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/2_23089e0a-3f09-4677-9009-12f92c7f8fa4.png?8527693493550499837" className="img-responsive img-circle"/>For Him</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" data="For Kids" onClick={() => this.handleForWhoClick("For+Kids")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/For_Kids.png?10242007541718004116" className="img-responsive img-circle"/>For Kids</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3  col-xs-6" data="Newborn" onClick={() => this.handleForWhoClick("Newborn")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/1_fedf9350-9d93-490d-956b-251d9a94cf03.png?10242007541718004116" className="img-responsive img-circle"/>Newborn</button>
                                    </div>
                                </div>
                            }
                            {
                                questionSequence === 2 &&
                                <div className="form-group container">    
                                    <div className="row">
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleBudgetClick("0%2C100")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/Below_RM100.jpg?16132417513882154720" className="img-responsive img-circle"/>Under RM100</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleBudgetClick("100%2C200")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/RM100-200.jpg?16132417513882154720" className="img-responsive img-circle"/>RM100-RM200</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleBudgetClick("200%2C300")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/RM200-300.jpg?16132417513882154720" className="img-responsive img-circle"/>RM200-RM300</button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleBudgetClick("300%2C9999")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/RM300_and_above.jpg?16132417513882154720" className="img-responsive img-circle"/>RM300 & Above</button>
                                    </div>
                                </div>
                            }
                            {
                                questionSequence === 3 &&
                                <div className="form-group container">    
                                    <div className="row">
                                        <button type="button" className="btn btn-default btn-lg btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleLocationClick("KL+%26+Selangor+(On-Demand+Delivery)")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/5_7418cc0f-907c-4abb-961b-2a4eb2b02a90.png?6042689504225728445" className="img-responsive img-circle"/>KL & Selangor</button>
                                        <button type="button" className="btn btn-default btn-lg btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleLocationClick("Nationwide+(Courier+Delivery)")}><img src="https://cdn.shopify.com/s/files/1/1428/2106/files/6_352f35d5-a8ba-4598-b8b1-bea4cc180968.png?6042689504225728445" className="img-responsive img-circle"/>Others</button>
                                    </div>
                                </div>
                            }
                            {
                                questionSequence === 4 &&
                                <div className="form-group container">  
                                    <div className="row">  
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleDeliveryClick("Same+Day+Delivery")}>
                                            <div className="gift-finder-date-wrapper">
                                                <span className="gift-finder-date">{moment().format("DD MMM")}</span><br/>
                                                <span className="gift-finder-time">{moment().format("ddd")}</span><br/>
                                            </div>
                                            <small>(Available only before 12pm)</small>
                                        </button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleDeliveryClick("Next+Day+Delivery")}>
                                            <div className="gift-finder-date-wrapper gift-finder-date-button ">
                                                <span className="gift-finder-date">{moment().add(1, 'd').format("DD MMM")}</span><br/>
                                                <span className="gift-finder-time">{moment().add(1, 'd').format("ddd")}</span>
                                            </div>
                                        </button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleDeliveryClick("Min.+2+Days+Booking")}>
                                            <div className="gift-finder-date-wrapper gift-finder-date-button ">
                                                <span className="gift-finder-date">{moment().add(2, 'd').format("DD MMM")}</span><br/>
                                                <span className="gift-finder-time">{moment().add(2, 'd').format("ddd")}</span>
                                            </div>
                                        </button>
                                        <button type="button" className="btn btn-default btn-lg col-lg-3 col-md-3 col-sm-3 col-xs-6" onClick={() => this.handleDeliveryClick("Min.+3+Days+Booking")}>
                                            <div className="gift-finder-date-wrapper">
                                                <span className="gift-finder-date">{moment().add(3, 'd').format("DD MMM")}</span><br/>
                                                <span className="gift-finder-time">{moment().add(3, 'd').format("ddd")}</span>
                                            </div>
                                            <small>onwards</small>
                                        </button>
                                    </div>
                                    <small>*The dates above are shown in Malaysia time zone (GMT+8)</small>
                                </div>
                            }
                            {
                                questionSequence === 5 &&
                                <div className="form-group">    
                                    <a target="_blank" href={`https://giftr.my/pages/search-results-page?page=1&rb_snize_facet4=${person}&rb_price=${budget}&rb_snize_facet1=${location}&rb_snize_facet2=${delivery}`} className="btn btn-lg btn-block btn btn-success">Click here to view it.</a>
                                    <button type="button" className="btn btn-default btn-lg btn-block" onClick={this.handleTryAgainClick}>Try Again</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(GiftFinder);